module.exports = __webpack_public_path__ + "static/img/vip-lv3.5d6c0fb0.png";